import React from "react";

const About = () => {
  return (
    <div className="pt-24 px-6 md:px-12">
      {/* Hero Section */}
      <section className="text-center mb-16">
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
          About <span className="text-blue-600">Our Company</span>
        </h1>
        <p className="text-white max-w-2xl mx-auto text-lg">
          We are a creative and technology-driven team passionate about building
          modern, scalable, and impactful digital solutions for clients worldwide.
        </p>
      </section>
      {/* Mission & Vision Section */}
      <section className="grid md:grid-cols-2 gap-10 items-center mb-20">
        <div><img
          src="https://images.pexels.com/photos/257736/pexels-photo-257736.jpeg"
          alt="About Illustration"
          className="w-full max-w-md mx-auto"     
        />
         <div class="absolute inset-0 bg-[#303030] mix-blend-overlay  pointer-events-none   "></div>    
        </div>
        <div>
          <h2 className="text-3xl font-bold text-white mb-4">
            Our Mission & Vision
          </h2>
          <p className="text-white mb-4 leading-relaxed">
            Our mission is to empower businesses with innovative technologies and
            creative design strategies that help them stand out in the digital world.
          </p>
          <p className="text-white leading-relaxed">
            We envision a world where every idea can come to life through seamless
            technology, impactful design, and authentic storytelling.
          </p>
        </div>
      </section>
      {/* Why Choose Us Section */}
      <section className="bg-[#030303] px-6 py-16 rounded-2xl mb-20">
        <h2 className="text-3xl font-bold text-center mb-10 text-white">
          Why Choose Us
        </h2>
        <div className="grid md:grid-cols-3 gap-8">
          {[
            {
              title: "Innovative Solutions",
              desc: "We deliver cutting-edge digital products tailored to your business needs.",
            },
            {
              title: "Dedicated Team",
              desc: "Our team works passionately to ensure every project exceeds expectations.",
            },
            {
              title: "Client-Centered Approach",
              desc: "We focus on your goals and collaborate closely for the best results.",
            },
          ].map((item, i) => (
            <div
              key={i}
              className="bg-white p-8 rounded-xl shadow hover:shadow-lg transition-all duration-300 text-center"
            >
              <h3 className="text-xl font-semibold text-blue-600 mb-3">
                {item.title}
              </h3>
              <p className="text-gray-600">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>
      {/* Team Section */}
      <section className="px-6 py-16 mb-20 text-center">
        <h2 className="text-3xl font-bold text-white mb-10">Meet Our Team</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {[
            {
              name: "Adeel Ahmad",
              role: "CEO / Founder",
              img: "Adeel.png",
            },
            {
              name: "Ahmad",
              role: "Frontend  Developer",
              img: "https://th.bing.com/th/id/OIP.Fu2wgpzFGmK7i00vnJCMpQHaE7?w=269&h=180&c=7&r=0&o=7&cb=ucfimg2&dpr=1.5&pid=1.7&rm=3&ucfimg=1",
            },
            {
              name: "Waseem Abbas",
              role: "Full Stack Developer",
              img: "waseem.png",
            },
            {
              name: "Rashid",
              role: "Backend Developer",
              img: "https://th.bing.com/th/id/OIP.lU_ywkpCWwzP8DYOn9bxIAHaFo?w=212&h=180&c=7&r=0&o=7&cb=ucfimg2&dpr=1.5&pid=1.7&rm=3&ucfimg=1",
            },
          ].map((member, i) => (
            <div
              key={i}
              className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition-all duration-300"
            >
              <img
                src={member.img}
                alt={member.name}
                className="w-32 h-32 object-cover rounded-full mx-auto mb-4 border-4 border-blue-100"
              />
              <h3 className="text-lg font-semibold text-gray-900">
                {member.name}
              </h3>
              <p className="text-blue-600 text-sm">{member.role}</p>
            </div>
          ))}
        </div>
      </section>
      {/* Stats Section */}
      <section className="bg-[#030303] text-white py-16 rounded-2xl text-center">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {[
            { number: "50+", label: "Projects Completed" },
            { number: "20+", label: "Happy Clients" },
            { number: "5+", label: "Years of Experience" },
            { number: "10+", label: "Team Members" },
          ].map((stat, i) => (
            <div key={i}>
              <h3 className="text-4xl font-bold mb-2">{stat.number}</h3>
              <p className="text-blue-100 font-medium">{stat.label}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};
export default About;